//angular imports
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

//local imports
import { AbstractProjectModel } from '@app/catalog-common';

@Component({
  selector: 'project-item',
  templateUrl: './project-item.component.html',
  styleUrl: './project-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ProjectItemComponent {
  public project = input.required<AbstractProjectModel>();
}
